import { Route } from "@angular/router";
import { HomePage } from "./home.page";

export const HomeRouter: Route[] = [
  { path: 'home', component: HomePage }
];
